import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 283,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
      background: COLORS.gray.white,
      boxShadow: '0px 1px 27px rgba(31, 44, 75, 0.1)',
      border: `1px solid ${COLORS.primary.light}`,
      borderRadius: 6,
      zIndex: theme.zIndex.modal,
      userSelect: 'none',
    },
    title: {
      color: COLORS.neutral.secondary,
    },
    link: {
      ...theme.typography.regular12,
      color: COLORS.primary.default,
      textDecoration: 'underline',
      flex: 1,
      whiteSpace: 'nowrap',
      maxWidth: 150,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    button: {
      margin: theme.spacing(-0.5), // account for button padding
      marginLeft: 'auto',
    },
    icon: {
      color: COLORS.neutral.mediumGray,
    },
  }),
  { name: 'LinkViewPopover' }
);
